import db from './database';
import api from '@/apicollection';

const tehtava_attachments = {};

const addSyncRequest = async tag => {
  if ('serviceWorker' in navigator && 'SyncManager' in window) {
    const sw = await navigator.serviceWorker.ready;
    console.log('register sync request', { tag });
    await sw.sync.register(tag);
  }
};

const TAGS = {
  TEHTAVA_ATTACHMENTS: 'sync-tehtava-attachments',
};

const backgroundSendingService = {
  async sendTehtavaAttachments(ids) {
    console.log('send tehtava attachments');
    for (let i = 0; i < ids.length; i++) {
      const id = ids[i];
      if (!(id in tehtava_attachments)) {
        tehtava_attachments[id] = true;
      } else {
        throw new Error('file already being uploaded');
      }
      const attachmentData = await db.getAttachment(id);
      try {
        const { tehtavanro, lisatiedot, fileDataUrl, fileName, type, fileType } = attachmentData;
        await api.addTehtavanLiite(tehtavanro, lisatiedot, fileDataUrl, fileName, type, fileType);

        await db.deleteAttachment(id);
      } catch (error) {
        addSyncRequest(TAGS.TEHTAVA_ATTACHMENTS);
        throw error;
      } finally {
        delete tehtava_attachments[id];
      }
    }
  },
};

export default backgroundSendingService;
